import { http } from './api'

const resource = 'perfil-professor'

export default {
    
    index:(aaletivo, cdpessoal, cdmatric) => {
        return http.get(`${resource}/index/${aaletivo}/${cdpessoal}/${cdmatric}`)
    }

    
}
